import { render, staticRenderFns } from "./PolicyAdd.vue?vue&type=template&id=0c5a15d4&scoped=true"
import script from "./PolicyAdd.vue?vue&type=script&lang=js"
export * from "./PolicyAdd.vue?vue&type=script&lang=js"
import style0 from "./PolicyAdd.vue?vue&type=style&index=0&id=0c5a15d4&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0c5a15d4",
  null
  
)

export default component.exports